import * as React from "react";
import get from "lodash/get";

import { validate } from "../../utils/validators";
import * as actions from "../../actions";
import "./EmailTagInput.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { getEmailsFromString } from "../../utils/string";
import { flattenObject } from "../../utils/flattenObject";

export interface EmailTagInputProps extends ComponentBaseProps {
  formErrors: {
    [key: string]: { [index: string]: any };
  };
  onFormError: typeof actions.setWidgetFormError;
  onFormChange: typeof actions.setUserInput;
  clearWidgetFormError: typeof actions.clearWidgetFormError;
  shouldFocus?: boolean;
  style?: React.CSSProperties;
  placeholder?: string;
  value: string;
  name: string;
}

export interface EmailTagInputState {
  inputValue: string;
}

export class EmailTagInput extends ComponentBase<EmailTagInputProps> {
  componentDidUpdate(prevProps: EmailTagInputProps) {
    super.componentDidUpdate(prevProps);

    const current = get(this.props.data, this.props.name, "");
    const previous = get(prevProps.data, prevProps.name, "");

    // shareAgain empties the stored recipients, and the field holds its own
    // text, so without this the cleared value never reaches the screen.
    if (current !== previous && current !== this.state.inputValue) {
      this.setState({ inputValue: current });
    }
  }

  handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      inputValue: e.currentTarget.value,
    });

    this.onFormChange(e.currentTarget.value);
    // we want the error to clear as soon as you start typing in this field
    this.props.clearWidgetFormError("recipients");
  };

  validateEmailTagField = (setFormError: boolean) => {
    const { name, onFormError, data, validators } = this.props;

    if (validators && this.state.inputValue) {
      const recipients = getEmailsFromString(this.state.inputValue);
      const errorMessage = validate(validators, recipients, data);

      if (setFormError) {
        onFormError(name, errorMessage);
      }

      if (!this.props.isEditing) {
        this.setState({ errorMessage });
      }

      if (errorMessage) {
        return true;
      }
    }

    return false;
  };

  onBlur = () => {
    // this.validateEmailTagField(true);
  };

  render() {
    const { inputValue } = this.state;
    const { style, placeholder, isEditing } = this.props;
    const formErrors = flattenObject(get(this.props, "formErrors", {}));
    const hasError = formErrors[this.props.name];

    return (
      <>
        <input
          id={this.props.configName}
          type="text"
          placeholder={placeholder}
          value={inputValue}
          style={style}
          className={`EmailTagInput-container ${
            hasError ? "input-error" : ""
          } ${!isEditing ? "EmailTagInput-container-preview" : ""}`}
          onChange={this.handleOnChange}
          onBlur={this.onBlur}
          onDragStart={this.onDragStart}
          aria-label={get(this.props, "label", "")}
          tabIndex={0}
          ref={(component) => (this.component = component)}
        />
      </>
    );
  }
}
